import Index from "./pages/index/index";
// import Login from "./pages/login/index";
// import MaintenanceAdd from "./pages/maintenanceAdd/index";
// import MaintenanceItems from "./pages/maintenanceItems/index";
// import MaintenanceDetails from "./pages/maintenanceDetails/index";
import CarRentPayment from "./pages/carRentPayment/index";
import CollectionOnline from "./pages/collectionOnline/index";
import hgcPayment from "./pages/hgcPayment/index";

// 营销线上化
import MarketingOnlineIndex from "./marketingOnline/index/index";
import MarketingOnlineDetail from "./marketingOnline/detail/index";
import RemoteVehicleDetail from "./marketingOnline/vehicleDetail/index";
import MarketingOnlineActivity from "./marketingOnline/activity/index";
import MarketingOnlineHotCar from "./marketingOnline/hotcar/index";
import MarketingOnlineRentalCar from "./marketingOnline/rentalCar/index";
import MarketingOnlineMap from "./marketingOnline/map/index";

// 电子合同-待作废
import ACEntrance from "./authCertificate/ACEntrance/index";
import ACLogin from "./authCertificate/ACLogin/index";
import ACGuide from "./authCertificate/ACGuide/index";
import ACPersonalPapers from "./authCertificate/ACPersonalPapers/index";
import ACEnterprosePapers from "./authCertificate/ACEnterprosePapers/index";
import ACFaceCa from "./authCertificate/ACFaceCa/index";

//签署平台
import ACEntranceCompact from "./authCertificateCompact/ACEntrance/index";
import ACLoginCompact from "./authCertificateCompact/ACLogin/index";
import ACGuideCompact from "./authCertificateCompact/ACGuide/index";
import ACPersonalPapersCompact from "./authCertificateCompact/ACPersonalPapers/index";
import ACEnterprosePapersCompact from "./authCertificateCompact/ACEnterprosePapers/index";
import ACFaceCaCompact from "./authCertificateCompact/ACFaceCa/index";

// 邀新活动
import InvitationIndex from "./invitation/index/index";
import InvitationShareImg from "./invitation/shareImg/index";
import InvitationOpen from "./invitation/invitationOpen/index";

// 数据大屏
import huilian66 from "./dataScreen/index/index";

// 交车单收车单明细
import carBillDetails from "./carBillDetails/index/index";

// 吉利公告
import geelyNotice from "./geelyNotice/index/index";
import geelyNoticeDetail from "./geelyNotice/detail/index";

//出险查勘
import carClaimSurvey from "./carClaimSurvey/add/index";
//事故查勘
import carFaultSurvey from "./carFaultSurvey/add/index";
// 安全培训
import safetyTraining from "./safetyTraining/index/index";

// 客服中心
import customerServiceCenter from "./customerServiceCenter/index/index";
import customerServiceCenterDetail from "./customerServiceCenter/detail/index";

// 流程详情
import processReview from "./processReview/index";

// 远程慧联APP实名认证
import identityVerification from "./identityVerification/index";
import identificationResult from "./identityVerification/result/index";

// 邀新活动2021/12
import inviteNewUsersIndex from "./inviteNewUsers/index/index";
import inviteNewUsersDetail from "./inviteNewUsers/detail/index";
import inviteNewUsersShare from "./inviteNewUsers/share/index";
import inviteNewUsersDownload from "./inviteNewUsers/download/index";

//用户权益
import interestsConfig from "./interestsConfig/index";

//会员说明
import gradeDescription from "./gradeDescription/index";

// 发现
import find from "./find/index/index";
import findSafe from "./find/index/safeList";
import findDetail from "./find/detail/index";

// 新闻
import news from "./news/index/index";
import newsDetail from "./news/detail/index";

// 车辆保险
import carInsurance from "./carInsurance/index/index";
// 车辆培训
import carTrain from "./carTrain/index/index";
// 年审服务
import carAnnualReview from "./carAnnualReview/index/index";
// 上门送还车
import carHomeVisits from "./carHomeVisits/index/index";
// 替换车
import carReplace from "./carReplace/index/index";
// 维修保养
import carMaintenance from "./carMaintenance/index/index";
// 用车管家
import carSteward from "./carSteward/index/index";
// 租车指南
import carLeaseGuide from "./carLeaseGuide/index/index";
// 慧充电
import hicCharge from "./hicCharge/index/index";
// 慧保值
import preserveValue from "./preserveValue/index/index";
// 无忧租
import noSorrow from "./noSorrow/index/index";
// 易租购
import easyRentGo from "./easyrentgo/index/index";
// 试用租新
import trialLease from "./trialLease/index/index";
// 试用租
import onTrial from "./onTrial/index/index";
// 备用租
import spare from "./spare/index/index";
// 易损保
import easyToBreak from "./easyToBreak/index/index";
// 慧管车
import carManage from "./carManage/index/index";

// 充电运营商邀请注册
import yysChargingOperatorShare from "./yysChargingOperator/share/index";
import yysChargingOperatorDownload from "./yysChargingOperator/download/index";
import yysChargingOperatorIndex from "./yysChargingOperator/index/index";
import yysChargingOperatorDetail from "./yysChargingOperator/detail/index";
import yysChargingOperatorQr from "./yysChargingOperator/qr/index";

// 提现页
import withdrawal from "./withdrawal/index/index";
// 提现结果页
import WithdrawalResult from "./withdrawal/index/result";

// 绑定银行卡
import bindBank from "./bindBank/index/index";
import selectBank from "./bindBank/index/select";

// 提现记录
import withdrawalRecordsList from "./withdrawalRecordsList/index/index";
import withdrawalRecords from "./withdrawalRecordsList/index/record";

//违章安全教育考试
import safetyTrainingExam from "./safetyTrainingExam/index";
import safetyTrainingExamList from "./safetyTrainingExam/exam";

// 个人信息收集清单
import informationCollectionList from "./informationCollectionList/index/index";
import informationCollectionListBase from "./informationCollectionList/base/index";
import informationCollectionListIndentity from "./informationCollectionList/indentity/index";
import informationCollectionListBiology from "./informationCollectionList/biology/index";
import informationCollectionListAccount from "./informationCollectionList/account/index";
import informationCollectionListCarRental from "./informationCollectionList/carRental/index";
import informationCollectionListCharge from "./informationCollectionList/charge/index";
import informationCollectionListEquipment from "./informationCollectionList/equipment/index";

// 365摇一摇活动页
import peaceSharkIndex from "./peaceSharkIndex/index/index";
// 365摇一摇活动分享页
import peaceSharkShare from "./peaceSharkIndex/share/index";
// 365摇一摇学习排行榜
import peaceSharkRank from "./peaceSharkIndex/index/rank";
// 中奖记录
import peaceSharkRecord from "./peaceSharkIndex/record/index";

//百日行动抽奖
import hundredDaysActivities from "./hundredDaysActivities/index/index";
//百日行动中奖记录
import hundredDaysRecords from "./hundredDaysActivities/record/index";
//百日行动分享页
import hundredDaysActivitiesShare from "./hundredDaysActivities/share/index";

//百日行动
import peaceActivity from "./peaceSharkIndex/index/activity";

// 安全培训课程
import safetyTrainingCoursesIndex from "./safetyTrainingCourses/index/index";
import safetyTrainingCoursesRecord from "./safetyTrainingCourses/record/index";

// 车辆试用反馈表
import vehicleTrialFeedbackForm from "./vehicleTrialFeedbackForm/index/index";

// 二维码跳转
import transferQr from "./transferQr/index";

// 数字化营销活动
import ActivityModule from "./ActivityModule/index";
import ActivityModuleRule from "./ActivityModule/rule";
import ActivityModuleRecord from "./ActivityModule/record";

// 甲醇
import MethanolSiteIndex from "./MethanolSite/index";
import MethanolSiteDetail from "./MethanolSite/detail";

// 店铺详情
import storeDetail from "./storeDetail/index";

// 车辆询价
import vehicleInquiry from "./vehicleInquiry/index";
import vehicleInquiryInputPage from "./vehicleInquiry/inputPage";
import vehicleInquirySuccess from "./vehicleInquiry/success";
import vehicleInquiryChange from "./vehicleInquiry/change";
import vehicleInquiryRule from "./vehicleInquiry/rule";

import demo from "./demo/index";

export default [
    {
        path: "/index",
        component: Index,
        isLogin: false,
        isGongYing: false,
    },
    // 还款
    {
        path: "/carRentPayment",
        component: CarRentPayment,
        isLogin: false,
    },
    // 收款
    {
        path: "/collectionOnline",
        component: CollectionOnline,
        isLogin: false,
    },

    // 慧管车支付
    {
        path: "/hgcPayment",
        component: hgcPayment,
        isLogin: false,
    },

    // 营销线上化
    {
        path: "/MarketingOnlineIndex",
        component: MarketingOnlineIndex,
        isLogin: false,
        isWxLogin: false,
        title: "租绿牌货车，找远程慧联",
    },
    {
        path: "/MarketingOnlineDetail",
        component: MarketingOnlineDetail,
        isLogin: false,
        isWxLogin: false,
        title: "车辆详情",
    },
    {
        path: "/RemoteVehicleDetail",
        component: RemoteVehicleDetail,
        isLogin: false,
        isWxLogin: false,
        title: "远程车辆详情",
    },
    {
        path: "/MarketingOnlineActivity",
        component: MarketingOnlineActivity,
        isLogin: false,
        isWxLogin: false,
        title: "加入“司机共享计划”，享“三优租车”服务",
    },
    {
        path: "/MarketingOnlineHotCar",
        component: MarketingOnlineHotCar,
        isLogin: false,
        isWxLogin: false,
        title: "热门车型",
    },
    {
        path: "/MarketingOnlineRentalCar",
        component: MarketingOnlineRentalCar,
        isLogin: false,
        isWxLogin: false,
        title: "慧联租车",
    },
    {
        path: "/MarketingOnlineMap",
        component: MarketingOnlineMap,
        isLogin: false,
        isWxLogin: false,
        title: "地址查询",
    },
    // 签署认证-待作废
    {
        path: "/ACEntrance",
        component: ACEntrance,
        isLogin: false,
        isWxLogin: false,
        title: "线上签合同，成单合作更轻松",
    },
    {
        path: "/ACLogin",
        component: ACLogin,
        isLogin: false,
        isWxLogin: false,
        title: "登录",
    },
    {
        path: "/ACGuide",
        component: ACGuide,
        isLogin: false,
        isWxLogin: false,
        title: "引导",
    },
    {
        path: "/ACPersonalPapers",
        component: ACPersonalPapers,
        isLogin: false,
        isWxLogin: false,
        title: "个人认证",
    },
    {
        path: "/ACEnterprosePapers",
        component: ACEnterprosePapers,
        isLogin: false,
        isWxLogin: false,
        title: "企业认证",
    },
    {
        path: "/ACFaceCa",
        component: ACFaceCa,
        isLogin: false,
        isWxLogin: false,
        title: "认证结果",
    },

    //签署平台
    {
        path: "/ACEntranceCompact",
        component: ACEntranceCompact,
        isLogin: false,
        isWxLogin: false,
        title: "线上签合同，成单合作更轻松",
    },
    {
        path: "/ACLoginCompact",
        component: ACLoginCompact,
        isLogin: false,
        isWxLogin: false,
        title: "登录",
    },
    {
        path: "/ACGuideCompact",
        component: ACGuideCompact,
        isLogin: false,
        isWxLogin: false,
        title: "引导",
    },
    {
        path: "/ACPersonalPapersCompact",
        component: ACPersonalPapersCompact,
        isLogin: false,
        isWxLogin: false,
        title: "个人认证",
    },
    {
        path: "/ACEnterprosePapersCompact",
        component: ACEnterprosePapersCompact,
        isLogin: false,
        isWxLogin: false,
        title: "企业认证",
    },
    {
        path: "/ACFaceCaCompact",
        component: ACFaceCaCompact,
        isLogin: false,
        isWxLogin: false,
        title: "认证结果",
    },

    // 邀新活动
    {
        path: "/InvitationIndex",
        component: InvitationIndex,
        isLogin: false,
        isWxLogin: false,
        title: "邀请赚钱",
    },
    {
        path: "/InvitationShareImg",
        component: InvitationShareImg,
        isLogin: false,
        isWxLogin: false,
        title: "邀请图片",
    },
    {
        path: "/InvitationOpen",
        component: InvitationOpen,
        isLogin: false,
        isWxLogin: false,
        title: "马上选车",
    },
    // 数据大屏
    {
        path: "/huilian66",
        component: huilian66,
        isLogin: false,
        isWxLogin: false,
        title: "数据统计",
    },
    // 交车单收车单明细
    {
        path: "/carBillDetails",
        component: carBillDetails,
        isLogin: false,
        isWxLogin: false,
        title: "",
    },
    // 吉利公告
    {
        path: "/geelyNotice",
        component: geelyNotice,
        isLogin: false,
        isWxLogin: false,
        title: "公告列表",
    },
    {
        path: "/geelyNoticeDetail",
        component: geelyNoticeDetail,
        isLogin: false,
        isWxLogin: false,
        title: "",
    },
    {
        path: "/carClaimSurvey",
        component: carClaimSurvey,
        isLogin: false,
        isWxLogin: false,
        title: "事故查勘录入",
    },
    {
        path: "/carFaultSurvey",
        component: carFaultSurvey,
        isLogin: false,
        isWxLogin: false,
        title: "故障查勘录入",
    },
    // 安全培训
    {
        path: "/safetyTraining",
        component: safetyTraining,
        isLogin: false,
        isWxLogin: false,
        title: "安全培训",
    },
    // 客服中心
    {
        path: "/customerServiceCenter",
        component: customerServiceCenter,
        isLogin: false,
        isWxLogin: false,
        title: "客服中心",
    },
    {
        path: "/customerServiceCenterDetail",
        component: customerServiceCenterDetail,
        isLogin: false,
        isWxLogin: false,
        title: "查看解决方案",
    },
    // 流程详情
    {
        path: "/processReview",
        component: processReview,
        isLogin: false,
        isWxLogin: false,
        title: "",
    },
    // 远程慧联APP实名认证
    {
        path: "/identityVerification",
        component: identityVerification,
        isLogin: false,
        isWxLogin: false,
        title: "",
    },
    {
        path: "/identificationResult",
        component: identificationResult,
        isLogin: false,
        isWxLogin: false,
        title: "",
    },
    //车辆授权操作流程推广页
    // {
    //     path: '/CarAuthorization',
    //     component: CarAuthorization,
    //     isLogin: false,
    //     isWxLogin: false,
    //     title: '车辆授权操作流程'
    // }

    // 邀新活动2021/12
    {
        path: "/inviteNewUsersIndex",
        component: inviteNewUsersIndex,
        isLogin: false,
        isWxLogin: false,
        title: "邀请赚钱",
    },
    {
        path: "/inviteNewUsersDetail",
        component: inviteNewUsersDetail,
        isLogin: false,
        isWxLogin: false,
        title: "明细",
    },
    {
        path: "/inviteNewUsersShare",
        component: inviteNewUsersShare,
        isLogin: false,
        isWxLogin: false,
        title: "邀请赚钱",
    },
    {
        path: "/inviteNewUsersDownload",
        component: inviteNewUsersDownload,
        isLogin: false,
        isWxLogin: false,
        title: "领券成功",
    },

    //权益配置详情
    {
        path: "/interestsConfig",
        component: interestsConfig,
        isLogin: false,
        isWxLogin: false,
        title: "权益配置详情",
    },
    //会员说明
    {
        path: "/gradeDescription",
        component: gradeDescription,
        isLogin: false,
        isWxLogin: false,
        title: "会员说明",
    },
    // 发现
    {
        path: "/find",
        component: find,
        isLogin: false,
        isWxLogin: false,
        title: "发现",
    },
    {
        path: "/findSafe",
        component: findSafe,
        isLogin: false,
        isWxLogin: false,
        title: "发现",
    },
    {
        path: "/findDetail",
        component: findDetail,
        isLogin: false,
        isWxLogin: false,
        title: "动态",
    },
    // 新闻
    {
        path: "/news",
        component: news,
        isLogin: false,
        isWxLogin: false,
        title: "新闻中心",
    },
    {
        path: "/newsDetail",
        component: newsDetail,
        isLogin: false,
        isWxLogin: false,
        title: "详情",
    },
    // 车辆保险
    {
        path: "/carInsurance",
        component: carInsurance,
        isLogin: false,
        isWxLogin: false,
        title: "车辆保险",
    },
    // 车辆培训
    {
        path: "/carTrain",
        component: carTrain,
        isLogin: false,
        isWxLogin: false,
        title: "车辆培训",
    },
    // 年审服务
    {
        path: "/carAnnualReview",
        component: carAnnualReview,
        isLogin: false,
        isWxLogin: false,
        title: "年审服务",
    },
    // 上门送还车
    {
        path: "/carHomeVisits",
        component: carHomeVisits,
        isLogin: false,
        isWxLogin: false,
        title: "上门送还车",
    },
    // 替换车
    {
        path: "/carReplace",
        component: carReplace,
        isLogin: false,
        isWxLogin: false,
        title: "替换车",
    },
    // 维修保养
    {
        path: "/carMaintenance",
        component: carMaintenance,
        isLogin: false,
        isWxLogin: false,
        title: "维修保养",
    },
    // 用车管家
    {
        path: "/carSteward",
        component: carSteward,
        isLogin: false,
        isWxLogin: false,
        title: "用车管家",
    },
    // 租车指南
    {
        path: "/carLeaseGuide",
        component: carLeaseGuide,
        isLogin: false,
        isWxLogin: false,
        title: "租车指南",
    },
    // 慧充电
    {
        path: "/hicCharge",
        component: hicCharge,
        isLogin: false,
        isWxLogin: false,
        title: "慧充电",
    },
    // 慧保值
    {
        path: "/preserveValue",
        component: preserveValue,
        isLogin: false,
        isWxLogin: false,
        title: "慧保值",
    },
    // 无忧租
    {
        path: "/noSorrow",
        component: noSorrow,
        isLogin: false,
        isWxLogin: false,
        title: "无忧租",
    },
    // 易租购
    {
        path: "/easyRentGo",
        component: easyRentGo,
        isLogin: false,
        isWxLogin: false,
        title: "易租购",
    },
    // 试用租
    {
        path: "/trialLease",
        component: trialLease,
        isLogin: false,
        isWxLogin: false,
        title: "试用租",
    },
    // 试用车----app端取名是试用车，不用这个页面了
    {
        path: "/onTrial",
        component: onTrial,
        isLogin: false,
        isWxLogin: false,
        title: "试用租",
    },
    // 备用租
    {
        path: "/spare",
        component: spare,
        isLogin: false,
        isWxLogin: false,
        title: "备用租",
    },
    // 易损保
    {
        path: "/easyToBreak",
        component: easyToBreak,
        isLogin: false,
        isWxLogin: false,
        title: "易损保",
    },
    // 慧管车
    {
        path: "/carManage",
        component: carManage,
        isLogin: false,
        isWxLogin: false,
        title: "慧管车",
    },
    // 运营商邀请注册
    {
        path: "/yysChargingOperatorShare",
        component: yysChargingOperatorShare,
        isLogin: false,
        isWxLogin: false,
        title: "邀请用户",
    },
    {
        path: "/yysChargingOperatorDownload",
        component: yysChargingOperatorDownload,
        isLogin: false,
        isWxLogin: false,
        title: "绑定成功",
    },
    {
        path: "/yysChargingOperatorIndex",
        component: yysChargingOperatorIndex,
        isLogin: false,
        isWxLogin: false,
        title: "充电合伙人",
    },
    {
        path: "/yysChargingOperatorQr",
        component: yysChargingOperatorQr,
        isLogin: false,
        isWxLogin: false,
        title: "邀请二维码预览",
    },
    {
        path: "/yysChargingOperatorDetail",
        component: yysChargingOperatorDetail,
        isLogin: false,
        isWxLogin: false,
        title: "明细",
    },
    // 提现页
    {
        path: "/withdrawal",
        component: withdrawal,
        isLogin: false,
        isWxLogin: false,
        title: "提现",
    },
    // 提现结果页
    {
        path: "/WithdrawalResult",
        component: WithdrawalResult,
        isLogin: false,
        isWxLogin: false,
        title: "提现申请",
    },
    // 提现记录
    {
        path: "/withdrawalRecords",
        component: withdrawalRecords,
        isLogin: false,
        isWxLogin: false,
        title: "提现记录",
    },
    {
        path: "/withdrawalRecordsList",
        component: withdrawalRecordsList,
        isLogin: false,
        isWxLogin: false,
        title: "提现记录",
    },
    // 绑定银行卡
    {
        path: "/bindBank",
        component: bindBank,
        isLogin: false,
        isWxLogin: false,
        title: "绑定银行卡",
    },
    {
        path: "/selectBank",
        component: selectBank,
        isLogin: false,
        isWxLogin: false,
        title: "开户行选择",
    },
    // 违章安全教育考试
    {
        path: "/safetyTrainingExam",
        component: safetyTrainingExam,
        isLogin: false,
        isWxLogin: false,
        title: "安全教育考试",
    },
    {
        path: "/safetyTrainingExamList",
        component: safetyTrainingExamList,
        isLogin: false,
        isWxLogin: false,
        title: "安全教育考试",
    },
    // 个人信息收集清单
    {
        path: "/informationCollectionList",
        component: informationCollectionList,
        isLogin: false,
        isWxLogin: false,
        title: "个人信息收集清单",
    },
    // 365摇一摇活动页
    {
        path: "/peaceSharkIndex",
        component: peaceSharkIndex,
        isLogin: false,
        isWxLogin: false,
        title: "平安出行365",
    },
    {
        path: "/peaceSharkShare",
        component: peaceSharkShare,
        isLogin: false,
        isWxLogin: false,
        title: "平安出行365",
    },
    // 365排行榜
    {
        path: "/peaceSharkRank",
        component: peaceSharkRank,
        isLogin: false,
        isWxLogin: false,
        title: "挑战排行榜",
    },
    {
        path: "/peaceActivity",
        component: peaceActivity,
        isLogin: false,
        isWxLogin: false,
        title: "百日行动报名",
    },
    {
        path: "/informationCollectionListBase",
        component: informationCollectionListBase,
        isLogin: false,
        isWxLogin: false,
        title: "用户基本信息",
    },
    // 安全培训课程
    {
        path: "/safetyTrainingCoursesIndex",
        component: safetyTrainingCoursesIndex,
        isLogin: false,
        isWxLogin: false,
        title: "安全培训课程",
    },
    // 安全培训课程记录
    {
        path: "/safetyTrainingCoursesRecord",
        component: safetyTrainingCoursesRecord,
        isLogin: false,
        isWxLogin: false,
        title: "学习记录",
    },
    // 中奖记录
    {
        path: "/peaceSharkRecord",
        component: peaceSharkRecord,
        isLogin: false,
        isWxLogin: false,
        title: "中奖记录",
    },
    // 百日行动抽奖页
    {
        path: "/hundredDaysActivities",
        component: hundredDaysActivities,
        isLogin: false,
        isWxLogin: false,
        title: "百日行动抽奖",
    },
    // 百日行动中奖记录
    {
        path: "/hundredDaysRecords",
        component: hundredDaysRecords,
        isLogin: false,
        isWxLogin: false,
        title: "中奖记录",
    },
    // 百日行动分享页
    {
        path: "/hundredDaysActivitiesShare",
        component: hundredDaysActivitiesShare,
        isLogin: false,
        isWxLogin: false,
        title: "百日行动抽奖",
    },
    // 用户身份证明
    {
        path: "/informationCollectionListIndentity",
        component: informationCollectionListIndentity,
        isLogin: false,
        isWxLogin: false,
        title: "用户身份证明",
    },
    // 生物特征
    {
        path: "/informationCollectionListBiology",
        component: informationCollectionListBiology,
        isLogin: false,
        isWxLogin: false,
        title: "生物特征",
    },
    // 账号信息
    {
        path: "/informationCollectionListAccount",
        component: informationCollectionListAccount,
        isLogin: false,
        isWxLogin: false,
        title: "账号信息",
    },
    // 租车信息
    {
        path: "/informationCollectionListCarRental",
        component: informationCollectionListCarRental,
        isLogin: false,
        isWxLogin: false,
        title: "租车信息",
    },
    // 充电信息
    {
        path: "/informationCollectionListCharge",
        component: informationCollectionListCharge,
        isLogin: false,
        isWxLogin: false,
        title: "充电信息",
    },
    // 设备信息
    {
        path: "/informationCollectionListEquipment",
        component: informationCollectionListEquipment,
        isLogin: false,
        isWxLogin: false,
        title: "设备信息",
    },
    // 二维码跳转
    {
        path: "/transferQr",
        component: transferQr,
        isLogin: false,
        isWxLogin: false,
        title: "跳转中",
    },
    //车辆试用反馈表
    {
        path: "/vehicleTrialFeedbackForm",
        component: vehicleTrialFeedbackForm,
        isLogin: false,
        isWxLogin: false,
        title: "车辆试用反馈表",
    },
    //数字化营销活动
    {
        path: "/ActivityModule",
        component: ActivityModule,
        isLogin: false,
        isWxLogin: false,
        title: "   ",
    },
    {
        path: "/ActivityModuleRule",
        component: ActivityModuleRule,
        isLogin: false,
        isWxLogin: false,
        title: "活动规则",
    },
    {
        path: "/ActivityModuleRecord",
        component: ActivityModuleRecord,
        isLogin: false,
        isWxLogin: false,
        title: "我的奖励",
    },
    {
        path: "/MethanolSiteIndex",
        component: MethanolSiteIndex,
        isLogin: false,
        isWxLogin: false,
        title: "甲醇站列表",
    },
    {
        path: "/MethanolSiteDetail",
        component: MethanolSiteDetail,
        isLogin: false,
        isWxLogin: false,
        title: "甲醇站详情",
    },
    {
        path: "/storeDetail",
        component: storeDetail,
        isLogin: false,
        isWxLogin: false,
        title: "店铺简介",
    },
    {
        path: "/vehicleInquiry",
        component: vehicleInquiry,
        isLogin: false,
        isWxLogin: false,
        title: "车险询价",
    },
    {
        path: "/vehicleInquiryInputPage",
        component: vehicleInquiryInputPage,
        isLogin: false,
        isWxLogin: false,
        title: "信息录入",
    },
    {
        path: "/vehicleInquirySuccess",
        component: vehicleInquirySuccess,
        isLogin: false,
        isWxLogin: false,
        title: "询价结果",
    },
    {
        path: "/vehicleInquiryChange",
        component: vehicleInquiryChange,
        isLogin: false,
        isWxLogin: false,
        title: "更换手机号",
    },
    {
        path: "/vehicleInquiryRule",
        component: vehicleInquiryRule,
        isLogin: false,
        isWxLogin: false,
        title: "服务使用协议",
    },
    {
        path: "/demo",
        component: demo,
        isLogin: false,
        isWxLogin: false,
        title: "demo",
    },
];



// WEBPACK FOOTER //
// ./src/routeConfig.js